import React from 'react'
import './ImageStyleSheet.css';

function RogerThree() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger3.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerThree
